import { api } from '@/api/http';
import type { AuthSession, LoginInput } from '@/api/types';

export const authApi = {
  login: (input: LoginInput) => api.post<AuthSession>('/auth/login', input),
  logout: () => api.post('/auth/logout'),
  forgotPassword: (email: string) => api.post('/auth/forgot-password', { email }),
  resetPassword: (token: string, newPassword: string) => api.post('/auth/reset-password', { token, newPassword }),
  validateInvitation: (token: string) =>
    api.get<{ valid: boolean; email: string; name: string }>('/users/invitations/validate', { params: { token } }),
  completeInvitation: (input: { token: string; name: string; password: string; phone?: string }) =>
    api.post<{ userId: number }>('/users/invitations/complete', input),
};
